export default __webpack_public_path__ + "static/media/rightOutlined.bcc0d1d9.svg";